import ErrorPageView from "./ErrorPageView";

export const ErrorPageContainer = () => {
  return (
    <div>
      <ErrorPageView />
    </div>
  );
};
